<template>
  <div class="study-text appBody bg-grey-light ">
    <!--    <div class="shareImg position-fixed cursor-pointer">-->
    <!--      <img @click="onShare" src="/static/img/pro/share.png" alt="" class="">-->
    <!--    </div>-->
    <little-header></little-header>
    <div class="cover-img-div d-flex justify-content-center">
      <img class="cover-img" src="/static/img/session/exam_cover.png" alt="">
    </div>
    <div class="cover-title cover-margin font-15 line-16 text-primary text-center">
      {{sessionExamObj.title?sessionExamObj.title:''}}
    </div>
    <div class="cover-summary cover-margin van-multi-ellipsis--l3 color-66 font-12">
      {{sessionExamObj.summary}}
    </div>
    <div class="cover-tip mx-2r mt-12p border-bottom border-top">
      <van-row class="video-stat  mt-12p mb-3 align-items-start d-flex ">
        <img class="img-reminder" src="/static/img/session/reminder.png" alt="">
        <van-col class="mx-1 text-justify">
          <p v-if="!sessionExamObj.autoRemind" class="mb-0">{{ sessionExamObj.reminder }}</p>
          <div v-else class="font-12 color-0d">
            本次考试共有
            <span class="font-weight-600">
                 {{
                sessionExamObj.statInfo && sessionExamObj.statInfo.totalNum ? sessionExamObj.statInfo.totalNum : 0
              }}
              </span>
            道题，满分
            <span class="font-weight-600">
                {{
                sessionExamObj.statInfo && sessionExamObj.statInfo.totalScore ? sessionExamObj.statInfo.totalScore : 0
              }}
             </span>分，<span v-if="sessionExamObj.passmark">
            考试达标及格分数为
            <b class="font-weight-600">{{ sessionExamObj.passmark }}</b>
            分
          </span>
            <span class="" v-else>
               考试达标及格分数不限制
            </span>
            ，考试时间<span v-if="sessionExamObj.duration<=0">不限制。每人</span>
            <span v-else class="font-weight-600">{{sessionExamObj.duration|getVideoTimeStr}}</span>
            <span v-if="sessionExamObj.duration>0">，每人</span>
            <span class="text-primary" v-if="sessionExamObj.submitTimes">
             有{{sessionExamObj.submitTimes}}次考试机会
             </span>
            <span class="text-primary" v-else>
             考试次数不限制
             </span>
            。点击"开始考试"按钮，立即开始考试。
          </div>
        </van-col>
      </van-row>
    </div>
    <van-notice-bar class="font-10 cover-notice mx-2r"
                    wrapable
                    :scrollable="false"
                    text="* 考试规则：单题提交，系统自动提醒交卷，时间到系统自动提交"
    />

    <div class="cover-btn" v-if="!loading">
      <van-button round block type="info" @click="submit">开始考试</van-button>
    </div>
    <little-footer></little-footer>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {NavBar, Button, NoticeBar, Col, Row} from 'vant';
  import littleFooter from '@/page/lecturer/components/littleFooter';
  import LittleHeader from "@/components/littleHeader";
  import NoData from "@/components/noData";

  Vue.use(NoticeBar);
  Vue.use(NavBar);
  Vue.use(Button);
  Vue.use(Col);
  Vue.use(Row);

  export default {
    name: "examIndex",
    data() {
      return {
        username: '',
        type: '',
        userEId: '',
        canReset: false,
        loading: false,
        userExamInfo: {},
        startTime: 1598889600000,
        endTime: 1609430400000,
        sessionExamObj: {},
        userExamId: '',
        serverCurrentTime: 0,
      }
    },
    components: {
      LittleHeader,
      littleFooter,
      NoData
    },
    created() {
      if (this.sessionExam) {
        this.sessionExamObj = this.sessionExam;
      }
    },
    props: ['sessionExam', 'stat'],
    mounted() {
      if (!this.sessionExam) {
        this.sessionId = this.$route.params['id'];
        this.getSessionExamForLearner();
      }
      if (this.$route.query['uExamId']) {
        this.userEId = this.$route.query['uExamId'];
      }
    },
    methods: {
      getSessionExamForLearner() {
        this.loading = true;
        this.$store.dispatch('getSessionExamForLearnerUrl', {id: this.sessionId}).then((res) => {
          if (res) {
            this.sessionExamObj = res;
            if (res.duration > 0 && res.userSession && res.userSession.userExams && res.userSession.userExams.length > 0) {
              this.getServerCurrentTime();
              for (let model of res.userSession.userExams) {
                //没有完成继续开始，并且结束时间晚于当前时间 还能继续考试
                if (!model.finished &&
                  model.finishedTime &&
                  model.createdTime &&
                  this.serverCurrentTime &&
                  (model.finishedTime > this.serverCurrentTime ||
                    model.finishedTime === model.createdTime)) {
                  this.userExamId = model.id;
                  break;
                }
              }
            }
            this.loading = false;
          }

        })
      },
      getServerCurrentTime() {
        this.$store.dispatch('getServerCurrentTimeUrl', {}).then((time) => {
          this.serverCurrentTime = parseInt(time.data);
        })
      },
      submit() {
        if (!this.sessionExamObj.statInfo || !this.sessionExamObj.statInfo.totalNum || this.sessionExamObj.statInfo.totalNum < 1) {
          this.$toast('试卷暂未添加题目，请稍后进行答题！');
          return false;
        }
        this.$router.push({
          name: 'examText', params: {id: this.sessionExamObj.id},
          query: {duration: this.sessionExamObj.duration, uExamId: this.userExamId}
        });
      },
      // onShare() {
      //   //把生成海报需要的信息传入cookie
      //   this.shareObj = this.sessionExamObj;
      //   this.shareObj.qrcodeUrl = window.location.href;
      //   this.shareObj.fromPageType = 'session';
      //   localStorage.setItem('share_obj', JSON.stringify(this.shareObj));
      //   this.$router.push('/share-poster');
      // },
    }

  }
</script>

<style scoped lang="scss">
  $browser-default-font-size: 16px !default;
  @function pxTorem($px) {
    @return $px / $browser-default-font-size * 1rem;
  }

  .cover-img-div {
    margin-top: pxTorem(48px);

    .cover-img {
      height: pxTorem(102px);
    }
  }

  .cover-notice {
    color: #e7aa06;
    margin-top: pxTorem(10px);
    background-color: transparent !important;
    line-height: 1rem;
    padding: 0 !important;
  }

  .img-reminder {
    margin-top: pxTorem(3px);
    width: pxTorem(10px);
  }

  .cover-margin {
    margin: pxTorem(24px) pxTorem(32px) pxTorem(0px) pxTorem(32px);
  }

  .cover-btn {
    margin: pxTorem(80px) pxTorem(52px) pxTorem(32px) pxTorem(52px);
    height: pxTorem(36px);
    width: pxTorem(260px);

    button {
      width: 100%;
      height: 100%;
      font-size: pxTorem(13px);
      line-height: pxTorem(16px);
    }
  }

</style>
